import type { FramesClient } from "@connect/data/frames/client";
import { devConfigEnabled } from "../../../lib/parse-frame-config";
import { VGS_RESOURCE_PATHS, VGS_SUBMIT_HEADERS } from "../../../lib/vgs/constants";
import type { VgsSubmit } from "./cvc-api.types";

export async function tokenizeCvc(vgsSubmit: VgsSubmit, apiKey: string): Promise<string> {
  const tokenize = vgsSubmit(`${VGS_RESOURCE_PATHS.cvc}?apiKey=${apiKey}`, {
    method: "POST",
    withCredentials: true,
    headers: VGS_SUBMIT_HEADERS,
  }).then(({ status, response }) => {
    const token = response?.cvc;
    if (status !== 201 || typeof token !== "string" || !token) {
      throw new Error(`CVC tokenization failed (${status})`);
    }
    return token;
  });

  // devConfigEnabled is forced false in a production bundle, so a mock token is never minted there.
  if (!devConfigEnabled) {
    return tokenize;
  }
  return tokenize.catch((err: Error) => {
    // oxlint-disable-next-line no-console -- visibility for dev/E2E debugging
    console.warn("[cvc] VGS submit failed, using mock token:", err);
    return `mock_cvc_${Math.random().toString(36).slice(2, 10)}`;
  });
}

export async function saveCardCvc(client: FramesClient, cardId: string, cvc: string) {
  const { error, response } = await client.PATCH(
    "/platform/v1/frames/payment-methods/cards/{cardId}/cvc",
    { params: { path: { cardId } }, body: { cvc } },
  );

  if (error) {
    throw new Error(`save_cvc_failed_${response.status}`);
  }
}
